document.addEventListener('DOMContentLoaded', () => {
  // Disable Shopify’s built-in slider so it doesn’t clash
  document.querySelectorAll('slider-component').forEach(el => {
    el.removeAttribute('data-slider');
    el.classList.remove('slider');
  });

  // Find all product galleries on the page
  const galleries = document.querySelectorAll('[id^="Slider-Gallery-template--"]');
  if (!galleries.length) return;

  galleries.forEach(galleryEl => {
    galleryEl.className = 'flickity-gallery';
    galleryEl.style.overflow = 'hidden';

    // ----- 1) Identify & hide VIDEO slides before Flickity runs -----
    const allCells = Array.from(galleryEl.querySelectorAll('.product__media-item'));
    const isVideoCell = (cell) => !!cell.querySelector('deferred-media, video, iframe');

    // Build map of IMAGE cells (kept) and VIDEO cells (removed)
    const imageCells = [];
    const videoCells = [];
    allCells.forEach(cell => {
      if (isVideoCell(cell)) {
        cell.classList.add('has-video');
        cell.style.display = 'none';           // hide from DOM flow
        videoCells.push(cell);
      } else {
        imageCells.push(cell);
      }
    });

    // Create a lookup: media-id -> index within imageCells
    const idToImageIndex = new Map();
    imageCells.forEach((cell, i) => {
      const mediaId = cell.getAttribute('data-media-id'); // e.g. "template--xxx-6803..."
      if (mediaId) idToImageIndex.set(mediaId, i);
    });

    // ----- 2) Init Flickity on IMAGE cells only -----
    const flkty = new Flickity(galleryEl, {
      cellSelector: '.product__media-item:not(.has-video)',
      cellAlign: 'center',
      contain: true,
      draggable: true,
      wrapAround: true,
      imagesLoaded: true,
      lazyLoad: true,
      prevNextButtons: true,
      pageDots: false,
      adaptiveHeight: true,
      percentPosition: false
    });

    // Keep height in sync as images load
    galleryEl.querySelectorAll('img').forEach(img =>
      img.addEventListener('load', () => { flkty.resize(); })
    );
    window.addEventListener('resize', () => flkty.resize());

    // ----- 3) Remove video THUMBNAILS & wire visible thumbs to the right image index -----
    const thumbNav = galleryEl.closest('media-gallery')?.querySelector('[id^="Slider-Thumbnails-template--"]');
    if (thumbNav) {
      const thumbItems = Array.from(thumbNav.querySelectorAll('.thumbnail-list__item'));

      thumbItems.forEach(item => {
        // Shopify sets data-target to the media-id used above
        const targetId = item.getAttribute('data-target'); // e.g. "template--xxx-6803..."
        const pointsToImage = targetId && idToImageIndex.has(targetId);

        if (!pointsToImage) {
          // It's a video (or something not in the kept list) – hide the thumb
          item.style.display = 'none';
          return;
        }

        // It’s an image thumbnail we kept – wire click to the correct Flickity index
        const imageIndex = idToImageIndex.get(targetId);
        item.addEventListener('click', () => flkty.select(imageIndex));
      });

      // Update selected thumb state when the slide changes
      flkty.on('change', i => {
        const activeCell = imageCells[i];
        const activeId = activeCell?.getAttribute('data-media-id');
        thumbItems.forEach(item => item.classList.remove('is-selected'));
        if (activeId) {
          thumbItems.forEach(item => {
            if (item.getAttribute('data-target') === activeId) {
              item.classList.add('is-selected');
            }
          });
        }
      });
    }
  });
});